import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup
  .object({
    expenseName: yup.string().required("Expense name is required"),
    store: yup.string().required("Store is required"),
    amount: yup.string().required("Amount is required"),
    category: yup.string().required("Category is required"),
    paymentMethod: yup.string().required("Payment method is required"),
    expenseDate: yup.string().required("Expense date is required"),
    description: yup.string(),
    make_refund: yup.boolean(),
    bankCode: yup.string().when("make_refund", {
      is: true,
      then: yup.string().required("Bank is required"),
    }),
    accountNumber: yup.string().when("make_refund", {
      is: true,
      then: yup.string().required("A valid account number is required"),
    }),
    is_recurring: yup.boolean(),
    recurrenceFrequency: yup.string().when("is_recurring", {
      is: true,
      then: yup.string().required("Recurrence frequency is required"),
    }),
    recurrenceStartDate: yup.string().when("is_recurring", {
      is: true,
      then: yup.string().required("Recurrence start date is required"),
    }),
  })
  .required("All fields are required");

export const useValidation = ({ expenseDetails, isDisbursmentForm }) => {
  return useForm({
    resolver: yupResolver(schema),
    shouldFocusError: true,
    mode: "onBlur",
    defaultValues: {
      expenseName: expenseDetails?.name,
      store: `${expenseDetails?.store}`,
      amount: expenseDetails?.amount,
      category: `${expenseDetails?.category}`,
      paymentMethod: `${expenseDetails?.payment_method}`,
      expenseDate: expenseDetails?.expense_date,
      description: expenseDetails?.description,
      bankCode: expenseDetails?.bank_code,
      accountNumber: expenseDetails?.account_number,
      isDisbursmentForm: isDisbursmentForm,
      is_recurring: expenseDetails?.is_recurring,
      recurrenceFrequency: expenseDetails?.recurrence_frequency,
      recurrenceStartDate: expenseDetails?.recurrence_start_date,
    },
  });
};
